<template>
  <div class="lucky-numbers__market">
    <div class="lucky-numbers__market-buttons">
      <TabsSwift
        @clickViewBetslip="handleViewBetSlip"
        @clickAddBetslip="handleAddBetSlip"
        :tabs="tabs"
        :tabsMainMarket="tabsMainMarket"
        :tabsMoreMarket="tabsMoreMarket"
        :isPowerBall="isPowerBall"
        :numbersMainBallSet="numbersMainBallSet"
        :numbersPowerBallSet="numbersPowerBallSet"
        :numbersBonusBall="numberBonusMoreMarkets"
        :listPayouts="dataMainMarkets"
        :dataMoreMarkets="dataMoreMarkets"
        @clickItem="handleClickItemMoreMarket"
        @handleChosenItem="handleChosenNumber"
        @handleAddLine="handleAddLine"
        @handleDeleteItemChosen="handleDeleteItemChosen"
        @handleConfirmDeleteItemChosen="handleDeleteItemChosen"
        @cancelDeleteItem="isShowModalConfirmDelete = false"
        @quickPick="handleQuickPick"
        :listChosen="listChosen"
        :isShowModalConfirmDelete="isShowModalConfirmDelete"
      />
    </div>
    <ModalCommon
      v-if="showModalBetslip"
      @close="showModalBetslip = false"
      @login="handleLogin"
      @process-bet="handleProcessBet"
      @book-a-bet="handleBookABet"
      :isClassModalCustom="isModalCustomClass"
    >
      <YourBetslip
          :dataBetslip="listBetslips"
          :commonStake="commonStake"
          :totalStake="totalStake"
          :loading="loadingProcessBet"
          :loading-boot-a-bet="loadingBootABet"
          :is-disable-process-bet="isDisableProcessBet"
          :is-show-error-expired="isShowErrorExpired"
          :is-show-res-book-a-bet="isShowResBookABet"
          :booking-code-boot-a-bet="bookingCodeBootABet"
          @changeStake="handleChangeStake"
          @removeItemBetslip="handleRemoveItemBetslip"
          @removeAllBetslip="handleRemoveAllBetslips"
          @removeDrawsExpired="removeDrawsExpired"
          @moveToNextDraw="moveToNextDraw"
          @addClassModalClass="handleToggleClassModal"
      />
    </ModalCommon>
    <ModalCommon
        v-if="showModalProcessBet"
        @close="showModalProcessBet = false"
        @click-item="handleConfirmItem"
        @removeBetslip="listBetslips=[]"
    >
      <BetConfirmation />
    </ModalCommon>
    <ModalCommon
        v-if="showModalConfirmBet"
        @close="showModalConfirmBet = false"
        :refConfirm="refBetConfirmationDetail"
    >
      <BetConfirmationDetail />
    </ModalCommon>
  </div>
</template>
<script>
import TabsSwift from '@/components/common/tabs/tabs-swift.vue';
import ModalCommon from '@/components/common/modal/modal-common.vue';
import TabMainMarket from './tab-main-market/TabMainMarket';
import TabMoreMarkets from "./tab-more-markets/TabMoreMarkets";
import YourBetslip from "./betslip/YourBetslip";
import BetConfirmation from "./betslip/BetConfirmation";
import BetConfirmationDetail from "./betslip/BetConfirmationDetail";
import YourBetslipMixin from "../../mixins/betslip/your-betslip-mixin";
import TabMainBallSet from "./tab-main-market/TabMainBallSet";
import TabPowerBallSet from "./tab-main-market/TabPowerBallSet";

export default {
  mixins: [YourBetslipMixin],
  components: {
    TabsSwift,
    ModalCommon,
    YourBetslip,
    BetConfirmation,
    BetConfirmationDetail
  },
  data () {
    return {
      pickMax: 0,
      pickMin: 0,
      manualPicks: [],
      manualPickBonus: [],
      rules: {},
      rulesMain: {},
      rulesPower: {},
      rulesBonus: {},
      numbers: {},
      numbersMainBallSet: [],
      numbersPowerBallSet: [],
      numberBonusMoreMarkets: [],
      isShowModalConfirmDelete: false,
      // tabsNumber: [
      //   {
      //     title: 'MAIN BALL SET',
      //     href: 'main-ball-set',
      //     isActive: true,
      //     component: TabMainBallSet,
      //     classCustom: 'tab-main-ball-set tab-ball-set-common'
      //   },
      //   {
      //     title: 'BONUS BALL SET',
      //     href: 'power-ball-set',
      //     isActive: false,
      //     component: TabPowerBallSet,
      //     classCustom: 'tab-power-ball-set tab-ball-set-common'
      //   }
      // ],
      tabsMainMarket: [
        {
          title: 'MAIN BALL SET',
          href: 'main-ball-set',
          isActive: true,
          component: TabMainBallSet,
          classCustom: 'tab-main-ball-set tab-ball-set-common'
        }
      ],
      tabsMoreMarket: [
        {
          title: 'BONUS BALL SET',
          href: 'power-ball-set',
          isActive: true,
          component: TabPowerBallSet,
          classCustom: 'tab-power-ball-set tab-ball-set-common'
        }
      ],
      tabs: [
        {
          title: 'MAIN MARKET',
          href: 'main-market',
          isActive: true,
          component: TabMainMarket
        },
        {
          title: 'MORE MARKETS',
          href: 'more-market',
          isActive: false,
          component: TabMoreMarkets
        }
      ],
      listChosen: [{}],
      mainMarkets: [],
      moreMarkets: [],
      numbersMainMarkets: [832, 833, 834, 1000, 1001, 1002],
      main1Markets: [832, 833, 834],
      main2Markets: [1000, 1001, 1002],
      keyManualPicksBonus: [1000, 1001, 1002, 834],
      marketMaxPick: 832,
      bonusMarket: 1000,
      external_draw_id: null,
      dataDraws: [],
      isBonus: false,
      isMain: true,
      itemsActive: [],
      isPowerBall: true,
      maxPick: 0,
    }
  },
  computed: {
    markets() {
      return this.$store.getters.getMarkets
    },
    draws() {
      return this.$store.getters.getDraws
    },
    dataMainMarkets() {
      return this.mainMarkets;
    },
    dataMoreMarkets() {
      return this.moreMarkets
    }
  },
  watch: {
    markets(val) {
      if(val) {
        if(val.game.ballset.rules.length > 1) {
          this.tabsMoreMarket = [
            {
              title: (`${val.game.ballset.rules[1].name} BALL SET`).toUpperCase(),
              href: 'power-ball-set',
              isActive: true,
              component: TabPowerBallSet,
              classCustom: 'tab-power-ball-set tab-ball-set-common'
            }
          ]
        } else {
          this.tabsMainMarket = [
            {
              title: 'MAIN BALL SET',
              href: 'main-ball-set',
              isActive: true,
              component: TabMainBallSet,
              classCustom: 'tab-main-ball-set tab-ball-set-common'
            }
          ]
        }
        this.handleMainMoreMarkets(val.markets);
        this.handleSetRules(val.game.ballset.rules);
        this.handleSetDataChoosen(val.game);
      }
    },
    draws(val) {
      if(val) {
        this.dataDraws = val
      }
    },
  },
  methods: {
    handleSetDataChoosen(value) {
      this.external_draw_id = value.external_draw_id;
      const defaultChosen = this.defaultObjectChosen()
      this.listChosen = [defaultChosen]
    },
    handleSetRules(val) {
      this.rules = val;
      this.pickMax = val[0].picks_max;
      this.pickMin = val[0].picks_min;
      if(val[1] !== undefined) {
        this.rulesMain = val[0];
        this.rulesPower = val[1];
        this.rulesBonus = val[1];
        this.numbersMainBallSet = this.initNumbers(val[0].balls_min, val[0].balls_max, 'main')
        this.numbersPowerBallSet = this.initNumbers(val[1].balls_min, val[1].balls_max, 'power')
        this.isPowerBall = true
       } else {
        this.rulesMain = val[0];
        this.rulesPower = val[0];
        this.rulesBonus = val[0];
        this.numbersMainBallSet = this.initNumbers(val[0].balls_min, val[0].balls_max, 'main')
        this.isPowerBall = false;
        this.tabsMoreMarket = [];
      }
    },
    handleMainMoreMarkets(val) {
      let listItems = []
      let mainMarkets = [];
      let moreMarkets = [];
      for (const [_, item] of Object.entries(val)) {
        listItems = [...listItems, item.markets]
        for (const [key, value] of Object.entries(item.markets)) {
          if(this.numbersMainMarkets.includes(parseInt(key))) {
            if(Number(key) === this.marketMaxPick) {
              this.maxPick = Object.keys(value.outcomes).length;
            }
            const valueMainMarket = { ...value, key }
            mainMarkets.push(valueMainMarket)
          }
        }
        let value = { ...item, isActive: true}
        moreMarkets = [...moreMarkets, value]
      }
      moreMarkets = moreMarkets.filter(markets => {
        for (const [key, _] of Object.entries(markets.markets)) {
          return !this.numbersMainMarkets.includes(parseInt(key))
        }
      })
      // moreMarkets = moreMarkets.filter(item=> Object.keys(item.markets).length >= 1)
      let keyNumber = 1;
      moreMarkets.map(item => {
        for (const [key, value] of Object.entries(item.markets)) {
          if(value.select_numbers === 'yes') {
            let numbers = {};
            if(this.markets && this.markets.game && this.markets.game?.ballset.rules[1] !== undefined) {
              numbers = this.initNumbers(this.markets.game.ballset.rules[1].balls_min, this.markets.game.ballset.rules[1].balls_max, 'bonus', key)
            } else {
              numbers = this.initNumbers(this.markets.game.ballset.rules[0].balls_min, this.markets.game.ballset.rules[0].balls_max, 'bonus', key)
            }
            value.keyNumbers = key;
            this.numberBonusMoreMarkets.push({key, numbers, value})
          }
          keyNumber++;
          value.key = keyNumber;
          for (const [k, v] of Object.entries(value.outcomes)) {
            v.name = item.name;
            const valueText = v.specifier;
            if(valueText !== '') {
              v.text = v.text.replace('{value}', valueText)
              v.short_text = v.short_text.replace('{value}', valueText)
              value.description = value.description.replace('{value}', valueText)
            }
          }
          value.isActiveToggle = true;
        }
      })

      this.mainMarkets = mainMarkets;
      this.moreMarkets = moreMarkets;
    },
    handleClickItemMoreMarket(value) {
      let maxStake = 0;
      if(value.data.max_payout) {
        maxStake = parseInt(value.data.max_payout) / value.data.value.odds
      } else {
        if(this.accountSettings.payout_max) {
          maxStake = parseInt(this.accountSettings.payout_max) / value.data.value.odds
        }
      }
      let isAdd = true;
      let isReplace = false;
      this.listChosen.forEach(item => {
        if (item.key === value.data.data.key) {
          isAdd = false;
          isReplace = true;
        }
      })
      if (isAdd) {
        let outcome = '';
        for (const [k, v] of Object.entries(value.data.data.outcomes)) {
          if(value.data.value.text === v.text) {
            outcome = k
          }
        }
        const defaultChosen = {
          Main: [],
          slug: this.$store.state.paramsLuckyNumber?.slug,
          paid:  this.$filters.formatNumber(Number(this.accountSettings.bet_default)) || "",
          stake: this.$filters.formatNumber(Number(this.accountSettings.bet_default || 1)),
          stakeTaxAmount: "0.0000000000", //todo
          draws: 1, //todo
          market: value.market_id,
          outcome: outcome,
          numbers: [],
          summary: value.data.data.summary,
          text: value.data.value.text,
          numOfBets: "1", //todo
          startDrawId: '', //todo
          betType: "Single", //todo
          systemBets: [], //todo
          isFreeBet: false, //todo
          wheelingId: "", //todo
          maxPayout: null, //todo
          drawName: this.$store.state.paramsLuckyNumber?.drawName,
          MaxStake: maxStake,
          odds: Number(value.data.value.odds),
          toWin: parseInt(this.accountSettings.bet_default || 1) * Number(value.data.value.odds),
          moreDrawName: '',
        }
        if(this.listChosen[this.listChosen.length - 1].Main.length < 1
            && !this.listChosen[this.listChosen.length - 1].shortText
        ) {
          this.listChosen[this.listChosen.length - 1] =
              {
                ...defaultChosen,
                shortText: value.data.value.text,
                key: value.data.data.key,
                moreDrawName: value.data.data.summary
              };
        } else {
          this.listChosen = [...this.listChosen, defaultChosen]
          this.listChosen[this.listChosen.length - 1] =
              {
                ...this.listChosen[this.listChosen.length - 1],
                shortText: value.data.value.text,
                key: value.data.data.key,
                moreDrawName: value.data.data.summary
              };
        }
      }
      if (isReplace) {
        this.listChosen.forEach(item => {
          if (item.key === value.data.data.key) {
            item.shortText = value.data.value.text;
          }
        })
      }
    },
    handleQuickPick(data) {
      this.isBonus= false;
      this.isMain = true;
      const keyMarketQuickPick = parseInt(data.market.key);
      this.numbersPowerBallSet = this.initNumbers(this.rulesPower.balls_min, this.rulesPower.balls_max, 'power')
      this.numbersMainBallSet = this.initNumbers(this.rulesMain.balls_min, this.rulesMain.balls_max, 'main')
      if(this.main1Markets.includes(keyMarketQuickPick)) {
        this.isBonus = keyMarketQuickPick === 834;
      }
      if(this.main2Markets.includes(keyMarketQuickPick)) {
        this.isBonus = this.rules[1] !== undefined;
        if(keyMarketQuickPick === this.main2Markets[0] || keyMarketQuickPick === this.main2Markets[1]) {
          this.isMain = false
        }
      }
      let maxStake = 0;
      if(data.value.max_payout) {
        maxStake = parseInt(data.value.max_payout) / data.value.odds
      } else {
        if(this.accountSettings.payout_max) {
          maxStake = parseInt(this.accountSettings.payout_max) / data.value.odds
        }
      }
      let mainNumbers = []
      let allNumbers = [[]]
      if(this.isMain) {
        const numbers = Array(this.rules[0].balls_max).fill(this.rules[0].balls_max).map((_, index) => index + 1);
        numbers.sort(() => Math.random() - 0.5);
        const numbersRandomMain = numbers.slice(0, data.value.balls);
        allNumbers.unshift(numbersRandomMain)
        mainNumbers = numbersRandomMain.map(item => {
          return { number: item, isActive: false, type: 'main' }
        })
        this.numbersMainBallSet.forEach(item => item.isActive = numbersRandomMain.includes(item.number))
      }

      if(this.isBonus) {
        const numbersBonus = Array(this.rules[1].balls_max).fill(this.rules[1].balls_max).map((_, index) => index + 1);
        numbersBonus.sort(() => Math.random() - 0.5);
        const numbersRandomBonus = numbersBonus.slice(0, this.rules[1].picks_max);
        if(allNumbers.length === 2) {
          allNumbers[1] = numbersRandomBonus
        } else {
          allNumbers[0] = numbersRandomBonus
          allNumbers.push([])
        }
        numbersRandomBonus.map(item => {
          mainNumbers.push({ number: item, isActive: false, isBonus: true, type: 'bonus' })
        })
        this.numbersPowerBallSet.forEach(item => item.isActive = numbersRandomBonus.includes(item.number))
      }
      let outcome = '';
      for (const [k, v] of Object.entries(data.market.outcomes)) {
        if(data.value.text === v.text) {
          outcome = k
        }
      }
      const objectChosen = {
        Main: mainNumbers,
        slug: this.$store.state.paramsLuckyNumber?.slug,
        paid: this.$filters.formatNumber(Number(this.accountSettings.bet_default)) || "",
        stake: this.$filters.formatNumber(Number(this.accountSettings.bet_default || 1)),
        stakeTaxAmount: "0.0000000000", //todo
        draws: 1, //todo
        market: data.market.key,
        outcome: outcome,
        numbers: allNumbers,
        summary: data.market.summary,
        text: data.value.text,
        numOfBets: "1", //todo
        startDrawId: '', //todo
        betType: "Single", //todo
        systemBets: [], //todo
        isFreeBet: false, //todo
        wheelingId: "", //todo
        maxPayout: null, //todo
        Extra: "",
        drawName: this.$store.state.paramsLuckyNumber?.drawName,
        MaxStake: maxStake,
        odds: Number(data.value.odds),
        toWin: parseInt(this.accountSettings.bet_default || 1) * Number(data.value.odds),
        moreDrawName: '',
      }
      if(this.listChosen[this.listChosen.length - 1].Main.length === 0
          && !this.listChosen[this.listChosen.length - 1].shortText) {
        this.listChosen[this.listChosen.length - 1] = objectChosen;
      } else {
        this.listChosen = [...this.listChosen, {}]
        this.listChosen[this.listChosen.length - 1] = objectChosen;
      }
    },
    initNumbers(ballsMin, ballsMax, type, key) {
      return Array(ballsMax).fill(ballsMax).map((_, index) => {
        const number = index + ballsMin;
        return { number, isActive: false, type, key }
      })
    },
    handleAddLine() {
      const indexArr = this.listChosen.length - 1;
      if(this.listChosen[indexArr].Main
          && this.listChosen[indexArr].Main.length < this.rulesMain.balls_min
          && !this.listChosen[this.listChosen.length - 1].shortText
      ) {
        this.$toast.warning(`Please choose at least ${this.rulesMain.balls_min} numbers !`,
            { position: 'top-right' })
      } else {
        const defaultChosen = this.defaultObjectChosen()
        this.listChosen = [...this.listChosen, defaultChosen]
      }
      this.numbersMainBallSet = this.initNumbers(this.rulesMain.balls_min, this.rulesMain.balls_max, 'main')
      this.numbersPowerBallSet = this.initNumbers(this.rulesPower.balls_min, this.rulesPower.balls_max, 'power')
    },
    handleChosenNumber(value) {
      switch (value.type) {
        case 'main':
          this.itemsActive = this.numbersMainBallSet.filter(item => item.isActive === true);
          this.pickMax = this.maxPick;
          this.pickMin = this.rulesMain.picks_min;
          this.handleForEachChangeActive(this.numbersMainBallSet, value.index.number, 'main')
          break;
        case 'power':
          this.itemsActive = this.numbersPowerBallSet.filter(item => item.isActive === true);
          this.pickMax = this.rulesPower.picks_max;
          this.pickMin = this.rulesPower.picks_min;
          this.handleForEachChangeActive(this.numbersPowerBallSet, value.index.number, 'power')
          break;
        case 'bonus':
          this.numberBonusMoreMarkets.forEach(item => {
            if (value.index.key === item.key) {
              this.itemsActive = item.numbers.filter(item => item.isActive === true);
              item.numbers.forEach((number, _) => {
                number.isActive = number.number === value.index.number;
              })
            }
          })
          this.pickMax = this.rulesBonus.picks_max;
          this.pickMin = this.rulesBonus.picks_min;
          break;
      }
      for (const [_, value] of Object.entries(this.mainMarkets)) {
        if(this.keyManualPicksBonus.includes(Number(value.key))) {
          for (const [_, v] of Object.entries(value.outcomes)) {
            this.manualPickBonus.push({outcome: v, market: value})
          }
        } else {
          for (const [_, v] of Object.entries(value.outcomes)) {
            this.manualPicks.push({outcome: v, market: value})
          }
        }
      }
      this.manualPicks = this.manualPicks.filter((value, index, self) =>
          index === self.findIndex((t) => (
              t.outcome.balls === value.outcome.balls
          ))
      )
      this.manualPickBonus = this.manualPickBonus.filter((value, index, self) =>
          index === self.findIndex((t) => (
              t.outcome.balls === value.outcome.balls
          ))
      )
      let isExistNumber = false;
      this.listChosen[this.listChosen.length - 1].Main.forEach(item => {
        if (item.number === value.index.number && value.type === item.type) {
          isExistNumber = true;
        }
      })
      let numbersLength = 0;
      let maxStake = 0;
      let odds = 0;
      let market = '';
      let summary = '';
      let text = '';
      let outcome = '';
      let numbers = [[]];
      numbersLength = this.listChosen[this.listChosen.length - 1].Main.length > 0 ? this.listChosen[this.listChosen.length - 1].Main.length - 1 : 0;
      if(value.type === 'bonus') {
        let isUpdate = false;
        // this.listChosen.forEach(item => {
        //   if(item.Main[0]?.key === value.index?.key) {
        //     item.Main.forEach(number => {
        //       if(number.key === value.index.key) {
        //         isUpdate = true;
        //         number.number = value.index.number;
        //         numbers.unshift([number.number])
        //       }
        //     })
        //   }
        // })
        if(!isUpdate) {
          const defaultChosen = this.defaultObjectChosen()
          if(this.listChosen[this.listChosen.length - 1].Main.length === 0
              && !this.listChosen[this.listChosen.length - 1].shortText
              || this.listChosen[this.listChosen.length - 1].Main[numbersLength]?.type === 'bonus'
              && this.listChosen[this.listChosen.length - 1].Main[numbersLength]?.key === value.index.key) {
            if (isExistNumber) {
              this.listChosen[this.listChosen.length - 1].Main.pop()
            } else {
              numbersLength = this.listChosen[this.listChosen.length - 1].Main.length > 0 ? this.listChosen[this.listChosen.length - 1].Main.length - 1 : 0;
              this.listChosen[this.listChosen.length - 1].Main[numbersLength] = {number: value.index.number, isActive: true, type: value.type, key: value.index.key}
            }
          } else {
            this.listChosen = [...this.listChosen, defaultChosen]
            this.listChosen[this.listChosen.length - 1].Main[0] = {number: value.index.number, isActive: true, type: value.type, key: value.index.key}
          }
          this.numberBonusMoreMarkets.forEach(itemBonus => {
            if(value.index.key === itemBonus.key) {
              for (const [k, v] of Object.entries(itemBonus.value.outcomes)) {
                odds = v.odds;
                market = itemBonus.value.keyNumbers;
                summary = itemBonus.value.summary;
                text = v.text;
                outcome = k;
                if(v.max_payout) {
                  maxStake = parseInt(v.max_payout) / odds
                } else {
                  if(this.accountSettings.payout_max) {
                    maxStake = parseInt(this.accountSettings.payout_max) / odds
                  }
                }
              }
            }
          })
          this.listChosen[this.listChosen.length - 1].Main.forEach(item => {
            if(item.type === 'bonus' || item.type === 'power') {
              if(numbers.length === 2) {
                numbers[numbers.length-1].push(item.number)
              } else {
                numbers.push([])
                numbers[numbers.length-1].push(item.number)
              }
            } else {
              numbers[0].push(item.number)
              if(numbers.length===1) {
                numbers.push([])
              }
            }
          })
        }
        this.listChosen[this.listChosen.length - 1] = {
          Main: this.listChosen[this.listChosen.length - 1].Main,
          slug: this.$store.state.paramsLuckyNumber?.slug,
          paid: this.$filters.formatNumber(Number(this.accountSettings.bet_default)) || "",
          stake: this.$filters.formatNumber(Number(this.accountSettings.bet_default || 1)),
          stakeTaxAmount: "0.0000000000", //todo
          draws: 1, //todo
          market: market,
          outcome: outcome,
          numbers: numbers,
          summary: summary,
          text: text,
          numOfBets: "1", //todo
          startDrawId: '', //todo
          betType: "Single", //todo
          systemBets: [], //todo
          isFreeBet: false, //todo
          wheelingId: "", //todo
          maxPayout: null, //todo
          Extra: "",
          drawName: this.$store.state.paramsLuckyNumber?.drawName,
          MaxStake: maxStake,
          odds: Number(odds),
          toWin: parseInt(this.accountSettings.bet_default || 1) * Number(odds),
          moreDrawName: '',
        }
      } else {
        if (this.itemsActive.length < this.pickMax || isExistNumber) {
          if (this.listChosen[this.listChosen.length - 1].Main.length !== 0) {
            if (isExistNumber) {
              if(value.type === 'power') {
                // this.listChosen[this.listChosen.length - 1].Main.pop()
              } else {
                this.listChosen[this.listChosen.length - 1].Main.forEach(function(item, index, object) {
                  if(item.type === 'main' && item.number === value.index.number) {
                    object.splice(index, 1);
                  }
                });
              }
            } else {
              if(value.type === 'power') {
                const typeLastNumber = this.listChosen[this.listChosen.length - 1].Main[numbersLength].type;
                if(typeLastNumber === 'power') {
                  this.listChosen[this.listChosen.length - 1].Main[numbersLength] = {number: value.index.number, isActive: true, type: value.type}
                } else {
                  this.listChosen[this.listChosen.length - 1].Main.push({number: value.index.number, isActive: true, type: value.type});
                }
              } else {
                this.listChosen[this.listChosen.length - 1].Main.unshift({number: value.index.number, isActive: true, type: value.type});
              }
            }
          } else {
            if(value.type === 'power') {
              this.listChosen[this.listChosen.length - 1].Main.push({number: value.index.number, isActive: true, type: value.type});
            } else {
              this.listChosen[this.listChosen.length - 1].Main.unshift({number: value.index.number, isActive: true, type: value.type});
            }
          }
        } else {
          if(value.type === 'power') {
            this.listChosen[this.listChosen.length - 1].Main[numbersLength] = {number: value.index.number, isActive: true, type: value.type}
          }
        }
        const even = (element) => element.type === 'power';
        if(this.listChosen[this.listChosen.length - 1].Main.some(even)) {
          this.manualPickBonus.forEach(item => {
            const numbers = this.listChosen[this.listChosen.length - 1].Main.filter(item => item.type === 'main')
            if(parseInt(item.outcome.balls) === numbers.length) {
              odds = item.outcome.odds;
              market = item.market.key;
              summary = item.market.summary;
              text = item.outcome.text;
              for (const [k, v] of Object.entries(item.market.outcomes)) {
                if(parseInt(item.outcome.balls) === parseInt(v.balls)) {
                  outcome = k;
                }
              }
              if(item.outcome.max_payout) {
                maxStake = parseInt(item.outcome.max_payout) / item.outcome.odds
              } else {
                if(this.accountSettings.payout_max) {
                  maxStake = parseInt(this.accountSettings.payout_max) / item.outcome.odds
                }
              }
            }
          })
        } else {
          const mainNumbers = this.listChosen[this.listChosen.length - 1].Main.filter(item => item.type === 'main')
          this.manualPicks.forEach(item => {
            if(parseInt(item.outcome.balls) === mainNumbers.length) {
              odds = item.outcome.odds;
              market = item.market.key;
              summary = item.market.summary;
              text = item.outcome.text;
              for (const [k, v] of Object.entries(item.market.outcomes)) {
                if(parseInt(item.outcome.balls) === parseInt(v.balls)) {
                  outcome = k;
                }
              }
              if(item.outcome.max_payout) {
                maxStake = parseInt(item.outcome.max_payout) / item.outcome.odds
              } else {
                if(this.accountSettings.payout_max) {
                  maxStake = parseInt(this.accountSettings.payout_max) / item.outcome.odds
                }
              }
            }
          })
        }
        this.listChosen[this.listChosen.length - 1].Main.forEach(item => {
          if(item.type === 'bonus' || item.type === 'power') {
            if(numbers.length === 2) {
              numbers[numbers.length-1].push(item.number)
            } else {
              numbers.push([])
              numbers[numbers.length-1].push(item.number)
            }
          } else {
            numbers[0].push(item.number)
            if(numbers.length===1) {
              numbers.push([])
            }
          }
        })
        this.listChosen[this.listChosen.length - 1] = {
          Main: this.listChosen[this.listChosen.length - 1].Main,
          slug: this.$store.state.paramsLuckyNumber?.slug,
          paid: this.$filters.formatNumber(Number(this.accountSettings.bet_default)) || "",
          stake: this.$filters.formatNumber(Number(this.accountSettings.bet_default || 1)),
          stakeTaxAmount: "0.0000000000", //todo
          draws: 1, //todo
          market: market,
          outcome: outcome,
          numbers: numbers,
          summary: summary,
          text: text,
          numOfBets: "1", //todo
          startDrawId: '', //todo
          betType: "Single", //todo
          systemBets: [], //todo
          isFreeBet: false, //todo
          wheelingId: "", //todo
          maxPayout: null, //todo
          Extra: "",
          drawName: this.$store.state.paramsLuckyNumber?.drawName,
          MaxStake: maxStake,
          odds: Number(odds),
          toWin: parseInt(this.accountSettings.bet_default || 1) * Number(odds),
          moreDrawName: '',
        }
      }
      if(value.index.type === 'power' && this.listChosen[this.listChosen.length - 1].Main.length === 1) {
        this.mainMarkets.forEach(item => {
          if(parseInt(item.key) === this.bonusMarket) {
            for (const [k, v] of Object.entries(item.outcomes)) {
              odds = v.odds;
              market = item.key;
              summary = item.summary;
              text = v.text;
              outcome = k;
              numbers[0].push(this.listChosen[this.listChosen.length - 1].Main[0].number);
              if(numbers.length===1) {
                numbers.push([]);
              } else {
                if(numbers.length===2) {
                  numbers[1]=[]
                }
              }
              if(v.max_payout) {
                maxStake = parseInt(v.max_payout) / odds
              } else {
                if(this.accountSettings.payout_max) {
                  maxStake = parseInt(this.accountSettings.payout_max) / odds
                }
              }
            }
          }
        })
        this.listChosen[this.listChosen.length - 1] = {
          Main: this.listChosen[this.listChosen.length - 1].Main,
          slug: this.$store.state.paramsLuckyNumber?.slug,
          paid: this.$filters.formatNumber(Number(this.accountSettings.bet_default)) || "",
          stake: this.$filters.formatNumber(Number(this.accountSettings.bet_default || 1)),
          stakeTaxAmount: "0.0000000000", //todo
          draws: 1, //todo
          market: market,
          outcome: outcome,
          numbers: numbers,
          summary: summary,
          text: text,
          numOfBets: "1", //todo
          startDrawId: '', //todo
          betType: "Single", //todo
          systemBets: [], //todo
          isFreeBet: false, //todo
          wheelingId: "", //todo
          maxPayout: null, //todo
          Extra: "",
          drawName: this.$store.state.paramsLuckyNumber?.drawName,
          MaxStake: maxStake,
          odds: Number(odds),
          toWin: parseInt(this.accountSettings.bet_default || 1) * Number(odds),
          moreDrawName: '',
        }
      }
    },
    handleForEachChangeActive(numbers, number, type) {
      numbers.forEach((value, i) => {
        if(type === 'power') {
          value.isActive = value.number === number;
        } else {
          if (this.itemsActive.length < this.pickMax || value.isActive) {
            if (value.number === number) {
              value.isActive = !value.isActive;
            }
          }
        }
      })
    },
    defaultObjectChosen() {
      return {
        Main: [],
        slug: this.$store.state.paramsLuckyNumber?.slug,
        paid: this.$filters.formatNumber(Number(this.accountSettings.bet_default)) || "",
        stake: this.$filters.formatNumber(Number(this.accountSettings.bet_default || 1)),
        stakeTaxAmount: "0.0000000000", //todo
        draws: 1, //todo
        market: '',
        outcome: '',
        numbers: [],
        summary: '',
        text: '',
        numOfBets: "1", //todo
        startDrawId: '', //todo
        betType: "Single", //todo
        systemBets: [], //todo
        isFreeBet: false, //todo
        wheelingId: "", //todo
        maxPayout: null, //todo
        Extra: "",
        drawName: this.$store.state.paramsLuckyNumber?.drawName,
        MaxStake: 0,
        odds: 0,
        toWin: 0,
        key: '',
        moreDrawName: '',
      }
    },
    handleDeleteItemChosen(value) {
      if(value === 1 && this.listChosen.length === 1) {
        const defaultChosen = this.defaultObjectChosen()
        this.listChosen = [defaultChosen]
      } else {
        this.listChosen = this.listChosen.filter((_, i) => value !== i+1)
      }
      this.isShowModalConfirmDelete = false;
      this.numbersMainBallSet = this.initNumbers(this.rulesMain.balls_min, this.rulesMain.balls_max, 'main')
      this.numbersPowerBallSet = this.initNumbers(this.rulesPower.balls_min, this.rulesPower.balls_max, 'power')
    },
    handleAddBetSlip() {
      if(this.dataDraws.length > 0) {
        let yourBetslipStorage = localStorage.getItem('yourBetslip')
        if(yourBetslipStorage && yourBetslipStorage.length > 0) {
          yourBetslipStorage = JSON.parse(yourBetslipStorage)
        }
        let arrBetslips = []
        this.listChosen.forEach(function(item, index, object) {
          if(item.shortText === undefined && item.Main.length === 0 && index !== 0) {
            object.splice(index, 1);
          }
        });
        if(this.listChosen[0].Main.length === 0 && this.listChosen[0].shortText === undefined) {
          return this.$toast.warning('Please select at least 1 number in the empty line',
              { position: 'top-right' })
        }
        this.dataDraws.forEach(item => {
          this.listChosen.map(ticket => {
            let newDrawName = '';
            ticket.startDrawId = item.external_draw_id;
            if(item.isMain) {
              ticket.drawDate = item.draw_date;
              newDrawName = `${ticket.drawName} ${item.draw_date}`
              arrBetslips.push({...ticket, newDrawName })
            }
            if(item.isPlus1) {
              ticket.drawDate = item.draw_date;
              newDrawName = `${ticket.drawName} Plus 1 ${item.draw_date}`
              ticket.drawName = `${ticket.drawName} Plus 1`
              ticket.slug = item.slugPlus1.slug;
              ticket.isMarketPlus = true;
              item.slugPlus1.draws.forEach(draw=> {
                if(item.draw_date === this.$filters.formatDate(draw.draw_date)) {
                  ticket.startDrawId = draw.external_draw_id
                }
              })
              arrBetslips.push({...ticket, newDrawName })
            }
            if(item.isPlus2) {
              ticket.drawDate = item.draw_date;
              ticket.drawName = ticket.drawName.replace('Plus 1', '');
              newDrawName = `${ticket.drawName} Plus 2 ${item.draw_date}`
              ticket.drawName = `${ticket.drawName} Plus 2`
              ticket.slug = item.slugPlus2.slug;
              ticket.isMarketPlus = true;
              item.slugPlus2.draws.forEach(draw=> {
                if(item.draw_date === this.$filters.formatDate(draw.draw_date)) {
                  ticket.startDrawId = draw.external_draw_id
                }
              })
              arrBetslips.push({...ticket, newDrawName })
            }
          })
        })
        arrBetslips.forEach(itemBetslip => {
          for (const property in this.markets.markets) {
            for (const key in this.markets.markets[property].markets) {
              if(Number(itemBetslip.market) === Number(key)) {
                itemBetslip.bets = this.markets.markets[property].markets[key]
              }
            }
          }
        })
        if(yourBetslipStorage && yourBetslipStorage.length > 0) {
          this.listBetslips = [...yourBetslipStorage, ...arrBetslips]
        } else {
          this.listBetslips = arrBetslips;
        }
        localStorage.setItem('yourBetslip', JSON.stringify(this.listBetslips))
        this.$store.dispatch('changeBadgeNumber', this.listBetslips.length);
        localStorage.setItem('draws', JSON.stringify(this.dataDraws))
        this.showModalBetslip=true
        const even = (element) => element.stake > element.MaxStake || element.stake === 0
            || element.stake === null || element.stake === '';
        this.isDisableProcessBet = this.listBetslips.some(even);
        this.numbersMainBallSet = this.initNumbers(this.rulesMain.balls_min, this.rulesMain.balls_max, 'main')
        this.numbersPowerBallSet = this.initNumbers(this.rulesPower.balls_min, this.rulesPower.balls_max, 'power')
        const defaultChosen = this.defaultObjectChosen()
        this.listChosen = [defaultChosen]
      } else {
        window.scrollTo(0,0);
        this.$toast.warning('Please select at least 1 draw!',
            { position: 'top-right' })
      }
    }
  }
}
</script>
